import React, { useState } from "react";

import {
  IgButton,
  IgChip,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import type { ConfigurationInputProps } from "../../../../../types/organization";
import { toProperCaseWithSpaces } from "../../../../../utils";

export const ListConfigInput = ({
  config,
  onChange,
}: ConfigurationInputProps) => {
  const [text, setText] = useState<string>("");

  // list unselect
  const handlePriceClassUnselect = (index: number) => {
    const selectedClasses = config.value.filter(
      (selected: any) => config.value.indexOf(selected) !== index
    );
    onChange(selectedClasses);
  };

  return (
    <Grid
      item
      container
      direction={"row"}
      alignItems={"center"}
      columnSpacing={2}
    >
      <Grid
        item
        xs={7}
        container
        direction={"row"}
        alignItems={"center"}
        columnSpacing={2}
      >
        <Grid item sx={{ minWidth: "350px" }}>
          <IgTypography>{toProperCaseWithSpaces(config.key)}:</IgTypography>
        </Grid>
        <Grid item>
          <IgTextField
            value={text}
            onChange={(e: any) => setText(e.target.value)}
            id="outlined-basic"
            // label="Price Class"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item>
          <IgButton
            style={{ marginRight: 15, textTransform: "none" }}
            size="medium"
            variant="outlined"
            onClick={() => {
              onChange([...config.value, text]); // append new value onto list
              setText("");
            }}
          >
            Add
          </IgButton>
        </Grid>
      </Grid>
      {config.value.length > 0 && (
        <Grid
          item
          container
          xs={5}
          direction={"row"}
          columnSpacing={1}
          rowSpacing={0.5}
        >
          {config.value.map((value: string, index: number) => (
            <Grid item key={index}>
              <IgChip
                onDelete={() => {
                  handlePriceClassUnselect(index);
                }}
                label={value}
                key={value}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};
